import React from 'react';

import { injectGlobal } from 'styled-components';

import {
  Content,
  LeftPanel,
  LeftSidebar,
  Main,
  PageLayout,
} from '@atlaskit/page-layout';

import { ExportTestCasesModal } from '@qality/common-components/src/organisms/ExportTestCases';

import { TestCaseRepositoryBulkBar } from '../TestCaseRepositoryBulkBar';
import { TestCaseRepositoryContent } from '../TestCaseRepositoryContent';
import { TestCaseRepositoryFilters } from '../TestCaseRepositoryFilters';
import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider';
import { TestCaseRepositoryHeader } from '../TestCaseRepositoryHeader';
import { TestCaseRepositoryOnboarding } from '../TestCaseRepositoryOnboarding';
import { TestCaseRepositorySidebarBody } from '../TestCaseRepositorySidebarBody';
import { TestCaseRepositorySidebarHeader } from '../TestCaseRepositorySidebarHeader';
import {
  DC_LEFT_SIDEBAR_POSITION_OVERRIDE,
  LeftSidebarContainerStyled,
  MainContainerStyled,
} from './TestCaseRepository.styled';

injectGlobal`
  ${DC_LEFT_SIDEBAR_POSITION_OVERRIDE};
`;

export default function TestCaseRepository(): JSX.Element {
  const { currentView } = useTestCaseRepositoryFoldersContext();

  const isOnboardingVisible = currentView === 'all-test-cases';

  return (
    <>
      <PageLayout>
        <Content>
          <LeftPanel width={8}>
            {/* Empty LeftPanel to add spacing between Jira Sidebar and our Sidebar */}
          </LeftPanel>
          <LeftSidebar shouldPersistWidth collapsedState='expanded'>
            <LeftSidebarContainerStyled>
              <TestCaseRepositorySidebarHeader />
              <TestCaseRepositorySidebarBody />
            </LeftSidebarContainerStyled>
          </LeftSidebar>
          <Main>
            <MainContainerStyled>
              {isOnboardingVisible && <TestCaseRepositoryOnboarding />}
              <TestCaseRepositoryHeader />
              <TestCaseRepositoryFilters />
              <TestCaseRepositoryContent />
              <TestCaseRepositoryBulkBar />
            </MainContainerStyled>
          </Main>
        </Content>
      </PageLayout>
      <ExportTestCasesModal />
    </>
  );
}
